import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    CircularProgress,
    Box,
    Typography
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { LoadingButton } from '@mui/lab';

const ConfirmMassActionDialog = ({
                                 open,
                                 title,
                                 selectedList,
                                 setSelectedList,
                                 onClose,
                                 actionFunction,
                                 environment,
                                 cachedItems,
                                 attribute

                             }) => {
    const [actionStatuses, setActionStatuses] = useState({});
    const [isProcessing, setIsProcessing] = useState(false);

    const getErrorMessage = (error) => {
        if (typeof error === 'string') return error;
        if (error?.data?.error) return error.data.error;
        if (error?.data?.message) return error.data.message;
        if (error?.message) return error.message;
        return 'Неизвестная ошибка';

    };


    const handleAction = async () => {
        setIsProcessing(true);
        const newStatuses = {};
        let hasErrors = false;

        for (let id in selectedList) {
            let itemId = cachedItems[selectedList[id]].item[attribute];

            if (newStatuses[itemId]?.status === 'success' || newStatuses[itemId]?.status === 'loading') {
                continue;
            }


            newStatuses[itemId] = {
                status: 'loading',
                error: null
            };
            setActionStatuses({...newStatuses});

            try {
                const response = await actionFunction({
                    environment: environment,
                    id: itemId
                });
                if (response?.error || response?.status >= 400) {
                    hasErrors = true;
                    newStatuses[itemId] = {
                        status: 'error',
                        error: getErrorMessage(response.error)
                    };
                } else {
                    newStatuses[itemId] = {
                        status: 'success',
                        error: null,
                        data: response
                    };
                }

            } catch (error) {
                hasErrors = true;
                newStatuses[itemId] = {
                    status: 'error',
                    error: error.message || 'Произошла ошибка'
                };
            }
            setActionStatuses({...newStatuses});
        }

        setIsProcessing(false);

        if (!hasErrors) {
            //setSelectedList([]);
            //onClose();
        }
    };

    const handleClose = () => {
        if (!isProcessing) {
            setSelectedList([]);
            setActionStatuses({});
            onClose();
        }
    };

    const formatGenerationTags = (generations) => {
        try {
            return Object.keys(generations).map((key) => (
                <><span key={key} className={"tag"}>
                        g{generations[key].generation}/v{generations[key].bundleVersion}
                    </span>&nbsp;</>
            ))
        } catch (e) {
            return <></>
        }

    }
    const getMappedBundle = (item) => {
        try {
            return {
                [item.bundleVersion]: {bundleVersion:item.bundleVersion, generation:item.generation},
                [item.prelastBundleVersion]: {bundleVersion:item.prelastBundleVersion, generation:item.prelastGeneration},
            }
        } catch (e) {
            return {}
        }
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xl"
            fullWidth={true}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Campaign Name</TableCell>
                                {attribute!=='id'&&<TableCell>{attribute}</TableCell>}
                                <TableCell>Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedList.map(item => (
                                <TableRow key={item}>
                                    <TableCell>{item}</TableCell>
                                    {attribute!=='id'&&<TableCell>{cachedItems[item].item[attribute]}</TableCell>}
                                    <TableCell>
                                        {!actionStatuses[cachedItems[item].item[attribute]] && (
                                            <span></span>
                                        )}
                                        {actionStatuses[cachedItems[item].item[attribute]]?.status === 'loading' && (
                                            <CircularProgress size={20} />
                                        )}
                                        {actionStatuses[cachedItems[item].item[attribute]]?.status === 'success' && (
                                            <Box sx={{color: 'success.main', display: 'flex', alignItems: 'center'}}>
                                                <CheckCircleIcon />
                                                {formatGenerationTags(getMappedBundle(cachedItems[item].bundle))} -> &nbsp;
                                                {attribute=='bundleId'&&<>{formatGenerationTags(actionStatuses[cachedItems[item].item[attribute]]?.data.data.generations)}</>}
                                            </Box>
                                        )}
                                        {actionStatuses[cachedItems[item].item[attribute]]?.status === 'error' && (
                                            <Box sx={{color: 'error.main', display: 'flex', alignItems: 'center', gap: 1}}>
                                                <CancelIcon />
                                                <Typography variant="caption" color="error">
                                                    {actionStatuses[cachedItems[item].item[attribute]].error}
                                                </Typography>
                                            </Box>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {!Object.keys(actionStatuses).length ? (
                    <>
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <LoadingButton
                            variant="contained"
                            onClick={handleAction}
                            disabled={selectedList.length === 0 || isProcessing}
                        >
                            Confirm
                        </LoadingButton>
                    </>
                ) : (
                    <Button
                        variant="contained"
                        onClick={handleClose}
                        disabled={isProcessing}
                    >
                        Close
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmMassActionDialog;